export default { sha: '524fe01bc495cb448889864970dd56352032cda1', buildNumber: 'undefined' }
